import { Box, Typography, useTheme } from "@mui/material";
import { Switcher } from "./Switcher";
import { IToggle } from "./Types/Toggle.types";

const LABEL_FONT_SIZE = "13px";

export const Toggle = ({
  id,
  checked,
  onChange,
  disabled = false,
  readOnly = false,
  label,
  noLabel,
  yesLabel,
  "aria-label": ariaLabel,
}: IToggle) => {
  const theme = useTheme();
  const inputLabel =
    ariaLabel ?? (typeof label === "string" ? label : undefined);

  return (
    <Box sx={{ display: "inline-flex", alignItems: "center", gap: 1 }}>
      {noLabel && (
        <Typography
          sx={{
            fontSize: LABEL_FONT_SIZE,
            fontWeight: checked ? 400 : 600,
            color: theme.palette.text.primary,
          }}
        >
          {noLabel}
        </Typography>
      )}
      <Switcher
        id={id}
        checked={checked}
        disabled={disabled}
        onChange={(_, next) => {
          if (!readOnly) onChange?.(next);
        }}
        inputProps={inputLabel ? { "aria-label": inputLabel } : undefined}
        sx={readOnly ? { pointerEvents: "none" } : undefined}
      />
      {yesLabel && (
        <Typography
          sx={{
            fontSize: LABEL_FONT_SIZE,
            fontWeight: checked ? 600 : 400,
            color: checked
              ? theme.palette.primary.main
              : theme.palette.text.primary,
          }}
        >
          {yesLabel}
        </Typography>
      )}
      {label && (
        <Typography
          sx={{
            fontSize: LABEL_FONT_SIZE,
            color: disabled
              ? theme.palette.text.disabled
              : theme.palette.text.primary,
          }}
        >
          {label}
        </Typography>
      )}
    </Box>
  );
};
